export enum ApiClaimObjectTypeCodeEnum {
    Conflict = 'CONF',
    Cost = 'KOST',
    Injury = 'LETS',
    Hide = 'NIET',
    Damage = 'SCHA',
    DamageOrInjury = 'SCLE',
}
